<button (click)="socialSignIn()" type="button"
  class="w-100 py-2 mb-3 btn google-btn-outline fs-16 fw-700 d-flex align-items-center justify-content-center">
  <img src="assets/images/icons/google.svg" alt="" class="mx-2"> {{dynamicText()}}
</button>